/**
 * Query key factories for consistent cache management
 */
export const queryKeys = {
  entitlement: (userId?: string) =>
    ['entitlement', userId].filter(Boolean),

  subscription: (userId?: string) =>
    ['subscription', userId].filter(Boolean),

  checkoutSession: (sessionId?: string) =>
    ['checkout-session', sessionId].filter(Boolean),
} as const;